module.exports = __webpack_public_path__ + "static/media/Swadloon_gaussian2.b7194d4e.png";